import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/Organisms/PageHeader/PageHeader";
import { PageLayout } from "@/components/Organisms/PageLayout/PageLayout";
import { useAppTranslation } from "@/hooks/use-app-translation";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/home",
)({
	component: DashboardPage,
});

function DashboardPage() {
	const { t } = useAppTranslation();

	return (
		<PageLayout
			header={
				<PageHeader
					type="landing"
					title={t("main.nav.items.home.label")}
					description={`${t("main.dashboard.welcomeBack")} ${t("main.dashboard.whatsHappening")}`}
				/>
			}
		>
			{null}
		</PageLayout>
	);
}
